export default "__VITE_ASSET__DeSLrWoa__"